export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_CRITERE_RECHERCHE_COMMANDES = 'SET_CRITERE_RECHERCHE_COMMANDES';
export const SET_PLAN_MEDIA_COURANT = 'SET_PLAN_MEDIA_COURANT';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
